<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break" id="_idParaDest-2"><span class="CharOverride-1"><a id="_idTextAnchor001"></a>CAST OF CHARACTERS</span></p>
<p class="ORIM-Chapter-Opener-Paragraph"><span class="CharOverride-1">Dane Thorson:</span><span class="CharOverride-2"> He wanted to spend a short vacation on Khatka, not the rest of his life.</span></p>
<p class="ORIM-Body-Text-Line-Break"><span class="CharOverride-1">Medic Tau: </span><span class="CharOverride-2">Was he physician or magician—or a little bit of both?</span></p>
<p class="ORIM-Body-Text-Line-Break"><span class="CharOverride-1">Chief Ranger Asaki:</span><span class="CharOverride-2"> Tracking the forests had taught him that mad animals—whether real or imaginary—were to be feared.</span></p>
<p class="ORIM-Body-Text-Line-Break"><span class="CharOverride-1">Captain Jellico:</span><span class="CharOverride-2"> Would his knowledge of alien life-forms help him in his fight against alien ghosts?</span></p>
<p class="ORIM-Body-Text-Line-Break"><span class="CharOverride-1">Nymani:</span><span class="CharOverride-2"> Not even this pilot’s most scientific skill could overcome a voodoo charm’s ground-drag.</span></p>
<p class="ORIM-Body-Text-Line-Break"><span class="CharOverride-1">Lumbrilo: </span><span class="CharOverride-2">On his own planet he was a witch doctor; on Earth he’d have been a master politician.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Voodoo_Planet-1.vue?223415dc